import { render, staticRenderFns } from "./BCXLazy.vue?vue&type=template&id=891f68f6"
import script from "./BCXLazy.vue?vue&type=script&lang=ts"
export * from "./BCXLazy.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports